{
  "header": "Votre agent a mis à jour vos informations d'achat / de réservation.",
  "uplift": {
    "subheader": "Votre agent vous enverra un nouveau lien de demande pour poursuivre avec Uplift."
  },
  "flexpay": {
    "subheader": "Votre agent vous enverra un nouveau lien de demande pour poursuivre avec Flex Pay."
  },
  "didNotRequest": "Si vous n'avez pas demandé d’apporter des changements à votre achat/réservation ou à vos renseignements personnels, veuillez vous adresser à votre agent."
}
